<!-- Zwei Hüllen, ein Inhalt. Eingebettet (AI_SETTINGS_EMBEDDED_SECTION,
     z.B. Agent › Wissen › „Quellen & Suche") stellt der Gastgeber Menü,
     Karte und Reiter; hier dann nur die Kacheln. -->
<ng-container *ngIf="embeddedSection; else standalone">
  <ng-container *ngIf="activeSection as section; else noSettings">
    <!-- Die Abschnittsbeschreibung stand vorher im Kartenkopf der eigenen
         Seite; im Reiter über den Kacheln (Twin-/Tutor-Varianten inklusive). -->
    <p *ngIf="section.descKey" class="section-card__desc section-embedded__desc">
      {{ section.descKey | translate }}
    </p>
    <ng-container *ngTemplateOutlet="tilesTpl; context: { $implicit: section }"></ng-container>
  </ng-container>
  <ng-template #noSettings>
    <p class="empty-body">{{ "pages.tutors.noSettings" | translate }}</p>
  </ng-template>
</ng-container>

<ng-template #standalone>
<app-tutor-menu>
  <nb-card
    class="section-card"
    [class.section-card--wide]="section.key === 'faq'"
    *ngIf="activeSection as section"
  >
    <nb-card-header>
      <h4>{{ section.labelKey | translate }}</h4>
      <p *ngIf="section.descKey" class="section-card__desc">
        {{ section.descKey | translate }}
      </p>
    </nb-card-header>
    <nb-card-body>
      <ng-container *ngIf="section.renderedTabs.length; else plainTiles">
        <nb-tabset class="section-tabs" (changeTab)="onSectionTabChange($event)">
          <nb-tab
            *ngFor="let tab of section.renderedTabs; trackBy: trackTab; let last = last"
            [tabId]="tab.key"
            [tabTitle]="tab.titleKey | translate"
            [tabIcon]="tab.icon"
            [active]="tab.key === activeTabKey"
          >
            <ng-container
              *ngTemplateOutlet="tilesTpl; context: { $implicit: section, tiles: tab.tiles, partial: !last }"
            ></ng-container>
          </nb-tab>
        </nb-tabset>
      </ng-container>
      <ng-template #plainTiles>
        <ng-container *ngTemplateOutlet="tilesTpl; context: { $implicit: section }"></ng-container>
      </ng-template>
    </nb-card-body>
  </nb-card>

  <nb-card *ngIf="!activeSection">
    <nb-card-body class="empty-body">
      <p>{{ "pages.tutors.noSettings" | translate }}</p>
    </nb-card-body>
  </nb-card>
</app-tutor-menu>
</ng-template>

<!-- `tiles` = the tiles of one section tab (else the whole section);
     `partial` = not the last tab, so the section-level extras below the
     tiles appear once, not per tab. -->
<ng-template #tilesTpl let-section let-tiles="tiles" let-partial="partial">
      <div class="tiles">
        <section
          *ngFor="let tile of (tiles || section.renderedTiles); trackBy: trackTile"
          class="tile-flat"
          [class.tile-flat--widget-tabs]="tile.isWidgetTabs"
          [class.tile-flat--faq]="tile.kind === 'faq'"
        >
          <header
            *ngIf="tile.titleKey || tile.hintKey"
            class="tile-flat__header"
          >
            <h5 *ngIf="tile.titleKey">{{ tile.titleKey | translate }}</h5>
            <p *ngIf="tile.hintKey" class="tile__hint">
              {{ tile.hintKey | translate }}
            </p>
          </header>
          <ng-container *ngFor="let s of tile.settings; trackBy: trackSetting">
            <!-- Settings gated by a visibility_rule are sub-options of the
                 toggle they depend on. Indent + left rail so a master and its
                 dependents (e.g. Geführter Lernmodus → Autostart/Vollbild)
                 read as one group. -->
            <div
              *ngIf="!isSuppressedByModelSelector(s)"
              class="setting-slot"
              [class.setting-slot--dependent]="isDependentSetting(s)"
            >
              <app-tutor-settings
                [tutorSetting]="s"
                [tutor]="tile.targetTutor || tutor"
                [linkedSetting]="(tile.linkedSettings || linkedSettings)[s.name]"
                [disabled]="tile.disabled || !!tile.disabledSettings?.[s.variable_name || '']"
                [disabledHintKey]="tile.disabledSettings?.[s.variable_name || ''] || tile.disabledHintKey"
                (settingValueSaved)="onSettingValueSaved($event)"
              >
              </app-tutor-settings>
            </div>
          </ng-container>

          <!-- „Themenspezifisch" only works with a „Fachgebiet": the field sits
               right here, and without a value the warning names the mode that
               really applies („Nur Wissensbasis", backend fallback). -->
          <ng-container *ngIf="isKnowledgeModeTile(tile)">
            <div
              class="knowledge-mode-note"
              [class.knowledge-mode-note--fallback]="!topicModeNote.topic"
              *ngIf="topicModeNote"
            >
              <p class="knowledge-mode-note__text">
                {{ 'enums.aiConfigurationNotes.knowledgeMode.topicExplain' | translate }}
              </p>
              <div class="knowledge-mode-note__topic" *ngIf="topicModeNote.topicSetting && tutor">
                <app-tutor-settings
                  [tutorSetting]="topicModeNote.topicSetting"
                  [tutor]="tutor"
                  (settingValueSaved)="onSettingValueSaved($event)"
                ></app-tutor-settings>
              </div>
              <p class="knowledge-mode-note__warn" role="status" *ngIf="!topicModeNote.topic">
                {{
                  (topicModeNote.topicSetting
                    ? 'enums.aiConfigurationNotes.knowledgeMode.topicFallback'
                    : 'enums.aiConfigurationNotes.knowledgeMode.topicNoField') | translate
                }}
              </p>
            </div>
          </ng-container>

          <!-- What the switches above actually reach. Below them, not above:
               it describes their effect, and the release it depends on lives
               on a different page where it is invisible from here. -->
          <div
            class="curriculum-coverage"
            *ngIf="isCurriculumTile(tile) && curriculumCoverage"
          >
            <p class="curriculum-coverage__head">
              Wirksam für {{ curriculumCoverage.courses_covered }} von
              {{ curriculumCoverage.courses_total }} Kursen dieses Agenten.
            </p>
            <ul class="curriculum-coverage__list" *ngIf="curriculumCoverage.programs.length">
              <li *ngFor="let p of curriculumCoverage.programs">
                <strong>{{ p.name }}</strong>
                <span class="muted"> — {{ p.course_count }} Kurse</span>
                <span class="muted" *ngIf="p.groups.length"> · {{ p.groups.join(' · ') }}</span>
              </li>
            </ul>
            <p class="curriculum-coverage__warn" *ngIf="curriculumUncovered">
              {{ curriculumUncovered }} Kurs{{ curriculumUncovered === 1 ? '' : 'e' }}
              dieses Agenten liegen in keinem freigegebenen Studiengang — im Bereich
              Curriculum freigeben.
            </p>
            <p class="curriculum-coverage__warn" *ngIf="!curriculumCoverage.courses_total">
              Dieser Agent ist in keinem Kurs platziert, daher greift die Einstellung nirgends.
            </p>
          </div>
          <!-- Granular model picker replaces the plain ai_provider dropdown
               when USE_GRANULAR_MODEL_SELECTOR is on (provider → concrete
               models + credit hints). Saves the same ai_provider setting. -->
          <app-model-selector
            *ngIf="providerSettingFor(tile) as providerSetting"
            alAnchor="setting.ai_provider"
            [tutor]="tutor"
            [providerSetting]="providerSetting"
            [settings]="settingsCache"
            [linkedSettings]="linkedDozentSettings"
            (settingValueSaved)="onSettingValueSaved($event)"
          ></app-model-selector>
          <!-- Custom-component tiles render below the toggle row.
               The FAQ tile drops a full Topic/Tags/Question/Answer
               editor backed by `bot_faqs`. -->
          <app-faq-list-form
            *ngIf="tile.kind === 'faq' && tutor"
            [tutor]="tutor"
            [enabled]="faqEnabled"
          ></app-faq-list-form>
          <!-- Twin only: which Moodle lecturers this Twin admits. Backed by
               `bot_moodle_dozent_access`, so it cannot ride the generic
               settings pipeline. Hidden while the switch above is off. -->
          <app-moodle-dozent-access
            *ngIf="isMoodleDozentTile(tile) && tutor && moodleDozentEnabled(tile)"
            [dozentBotId]="tutor.id"
            [audience]="moodleDozentAudience(tile)"
          ></app-moodle-dozent-access>
        </section>

        <section *ngIf="otherTile && !partial" class="tile-flat">
          <header class="tile-flat__header">
            <h5>{{ otherTile.titleKey | translate }}</h5>
          </header>
          <app-tutor-settings
            *ngFor="let s of otherTile.settings; trackBy: trackSetting"
            [tutorSetting]="s"
            [tutor]="tutor"
            [linkedSetting]="linkedSettings[s.name]"
            (settingValueSaved)="onSettingValueSaved($event)"
          >
          </app-tutor-settings>
        </section>

        <!-- Special-case tile: in the Dozent section, render the
             dozent-link picker. The link lives in `bot_dozent_link`
             (not `template_settings`), so the generic
             `app-tutor-settings` pipeline can't drive it. Shown only
             on tutor-bots (alpha_tutor / alpha_flexible) — the dozent
             bot itself doesn't link to another dozent. -->
        <section
          *ngIf="section.key === 'dozent' && tutor && isLinkableTemplate && !partial"
          class="tile-flat"
        >
          <header class="tile-flat__header">
            <h5>{{ 'tutor.dozentLink.title' | translate }}</h5>
          </header>
          <app-dozent-link-picker
            [tutorId]="tutor.id"
            (linkChanged)="onDozentLinkChanged($event)"
          ></app-dozent-link-picker>
        </section>
      </div>
</ng-template>
